import clsx from "clsx";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSettings } from "../../../context/SettingsContext";
import logobottom from "../../../assets/image/logo-bottom-new.png";
import { Button } from "../../Buttons";

interface WidgetFooterProps {
  isFeedbackActive: boolean;
  setIsFeedbackActive: (isActive: boolean) => void;
}

const WidgetFooter: React.FC<WidgetFooterProps> = ({
  isFeedbackActive,
  setIsFeedbackActive,
}) => {
  const { t } = useTranslation();
  const { widgetDataSettings, oversizeWidget } = useSettings();

  if (isFeedbackActive) return null;

  return (
    <div
      style={{
        position: "absolute",
        bottom: "0",
        left: "0",
        right: "0",
        height: "110px",
        borderRadius: "0.5rem",
        zIndex: 10,
      }}
      className="flex flex-row items-center justify-between mx-auto max-w-[100%] w-full bg-white p-3"
    >
      <div className="flex flex-col items-start w-[70%]">
        <p
          className={clsx(
            "text-[12px] leading-normal text-left w-full mb-3 text-black",
            oversizeWidget ? "!font-semibold" : undefined
          )}
        >
          {t("do_you_have_questions_or_want_to_send_feedback?")} <br />
        </p>
        <Button
          label={t("contact_us")}
          className="flex items-center p-2 w-[210px] sm:w-[150px] justify-center text-white text-sm font-medium rounded-full hover:opacity-90 transition-opacity min-w-[8rem] h-[2rem] break-words"
          style={{
            background: widgetDataSettings?.settings?.appearance?.colors
              ?.buttonColor
              ? widgetDataSettings?.settings?.appearance?.colors
                  ?.buttonGradientEnabled
                ? `linear-gradient(${widgetDataSettings.settings.appearance.colors.buttonColorGradient}, ${widgetDataSettings.settings.appearance.colors.buttonColor})`
                : widgetDataSettings.settings.appearance.colors.buttonColor
              : "#0048FF",
            borderRadius: "44px",
            fontWeight: oversizeWidget ? "600" : "normal",
          }}
          onClick={() => setIsFeedbackActive(true)}
        />
      </div>
      <img
        src={logobottom}
        alt="Logo"
        className="object-contain w-[47%] md:w-[37%] pr-7 h-auto pt-0"
      />
    </div>
  );
};

export default WidgetFooter;
